<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >

    <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <TableEntries
            v-model="perPage"
            :options="perPageOptions"
          />
          <Button
            v-if="getUserPermission('CREATE_BUSINESS_AUTOMATION')"
            :label="$t('Add')"
            size="md"
            @click="showModal('modal-lg')"
          />
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-lg-end">
            <Button
              :label="$t('Filter')"
              size="md"
              icon="FilterIcon"
              show-icon
              class="mr-1"
              @click="showModal('modal-filter')"
            />
            <Button
              :label="$t('Reset Filter')"
              size="md"
              icon="RotateCwIcon"
              show-icon
              @click="resetFilter"
            />
          </div>
        </b-col>
      </b-row>

    </div>

    <b-table
      ref="nterBranchAccountAccountRef"
      :busy="isBusy"
      :items="chequeReceivableAccountList"
      responsive
      :fields="translatedTableHeaders"
      primary-key="id"
      show-empty
      :empty-text="$t('No records available')"
      class="position-relative"
    >

      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner
            class="align-middle"
            variant="primary"
          />
        </div>
      </template>
      <template #cell(SN)="data">
        {{ getOverallIndex(data.index) }}
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">

        <div class="text-nowrap">
          <!-- Dropdown -->
          <b-dropdown
            variant="link"
            toggle-class="p-0"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              v-if="getUserPermission('MODIFY_BUSINESS_AUTOMATION')"
              @click="onSelectChequeReceivableAccount(data.item, $event.target, 'edit')"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50"> {{ $t('Modify') }} </span>
            </b-dropdown-item>

            <b-dropdown-item @click="onSelectChequeReceivableAccount(data.item, $event.target, 'view')">
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50"> {{ $('View') }} </span>
            </b-dropdown-item>
            <b-dropdown-item @click="onDeleteChequeReceivableAccount(data.item, $event.target)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50"> {{ $t('Delete') }} </span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>

    </b-table>

    <!-- Pagination -->
    <TablePagination
      v-model="currentPage"
      :from="from"
      :to="to"
      :total-rows="totalEntries"
      :per-page="perPage"
    />

    <!-- modal -->
    <b-modal
      id="modal-lg"
      ref="my-modal"
      no-close-on-backdrop
      :ok-title="buttonLabel"
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      :ok-disabled="isLoading"
      size="md"
      :title="modalTitle"
      @hidden="resetModal"
      @ok="handleSubmit"
    >
      <validation-observer ref="chequeReceivableAccountRules">
        <b-form @submit.prevent="handleSubmit">
          <b-row class="match-height">
            <!-- Claaring Bank Name -->
            <b-col md="12">
              <SelectField
                id="clearing-bank-name"
                v-model="chequeReceivableAccountFormData.clearingBankCode"
                :label="$t('Clearing Bank Name')"
                :options="bankOptions"
                :reduce="option => option.value"
                :error-name="$t('Clearing Bank Name')"
                rules="required"
                item="label"
                :placeholder="$t('Select')"
                :readonly="isReadonly"
                :loading="isLoadingBanks"
              />
            </b-col>
            <!-- Claearing Bank Name -->

            <!-- Cheque Receivable Account Number -->
            <b-col md="12">
              <SelectField
                id="mirrow-account"
                v-model="chequeReceivableAccountFormData.accountNumber"
                :label="$t('Cheque Receivable Account Number')"
                :options="chequeReceivableAccountNumberOptions"
                :reduce="option => option.value"
                :error-name="$t('Cheque Receivable Account Number')"
                rules="required"
                item="label"
                :placeholder="$t('Select')"
                :readonly="isReadonly"
              />
            </b-col>
            <!-- Cheque Receivable Account Number -->
          </b-row>

        </b-form>
      </validation-observer>
      <template
        v-if="isReadonly"
        #modal-footer="{ }"
      >
        <div />
      </template>
    </b-modal>
    <!-- modal -->

    <!-- Filter modal -->
    <b-modal
      id="modal-filter"
      ref="my-modal"
      :ok-title="$t('Apply')"
      no-close-on-backdrop
      :cancel-title="$t('Cancel')"
      cancel-variant="outline-secondary"
      centered
      size="md"
      :title="$t('Filters')"
      modal-footer
      @ok="fetchChequeReceivableAccount"
      @cancel="resetFilters"
    >
      <b-row class="match-height">
        <!-- Claearing Bank Name -->
        <b-col md="12">
          <SelectField
            id="clearing-bank-name"
            v-model="filter.clearingBankCode"
            :label="$t('Clearing Bank Name')"
            :options="bankOptions"
            :reduce="option => option.value"
            item="label"
            :placeholder="$t('Select')"
            :readonly="isReadonly"
            :loading="isLoadingBanks"
          />
        </b-col>
        <!-- Claearing Bank Name -->

        <!-- Cheque Receivable Account Number -->
        <b-col md="12">
          <SelectField
            id="mirrow-account"
            v-model="filter.accountNumber"
            :label="$t('Cheque Receivable Account Number')"
            :options="chequeReceivableAccountNumberOptions"
            :reduce="option => option.value"
            item="label"
            :placeholder="$t('Select')"
            :readonly="isReadonly"
          />
        </b-col>
        <!-- Cheque Receivable Account Number -->
      </b-row>
    </b-modal>
    <!-- Filter modal -->
  </b-card>

</template>

<script>
import {
  BCard, BRow, BCol, BTable, BModal, BSpinner,
  BForm, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import { mapActions, mapGetters } from 'vuex'
import { required } from '@validations'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { permissionMixin } from '@core/mixins/permission'
import { toAmount } from '@/helpers/formatAmount'
import TablePagination from '@/views/components/table/TablePagination.vue'
import TableEntries from '@/views/components/table/TableEntries.vue'
import SelectField from '../../../forms/SelectField.vue'
import Button from '../../../components/button/Button.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    TablePagination,
    TableEntries,
    Button,
    BTable,
    BSpinner,
    BModal,
    BForm,
    BDropdown,
    BDropdownItem,
    ValidationObserver,
    SelectField,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      isBusy: true,
      buttonLabel: this.$t('Save'),
      modalTitle: this.$t('Create Cheque Receivable Account'),
      isReadonly: false,
      isLoadingBanks: false,
      required,
      isRequired: false,
      isLoading: false,
      sortDesc: false,
      toAmount,
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'accountName', sortable: true, label: 'Account Name' },
        { key: 'accountNumber', sortable: true, label: 'Account Number' },
        { key: 'clearingBankName', sortable: true, label: 'Clearing Bank Name' },
        { key: 'actions', label: 'Actions' },
      ],
      chequeReceivableAccountFormData: {
        clearingBankCode: '',
        accountNumber: '',
      },
      chequeReceivableAccountList: [],
      chequeReceivableAccountNumberOptions: [],
      filter: {
        clearingBankCode: '',
        accountNumber: '',
      },
      // bankOptions: [],
    }
  },
  computed: {
    ...mapGetters({
      bankOptions: 'operations/bankOptions',
    }),
    translatedTableHeaders() {
      return this.tableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
  },
  mounted() {
    this.getAccounts()
    this.fetchChequeReceivableAccount()
    // this.fetchBanks()
  },
  methods: {
    ...mapActions({
      getChequeReceivableAccount: 'operations/getChequeReceivableAccountList',
      createChequeReceivableAccount: 'operations/createChequeReceivableAccountAction',
      updateChequeReceivableAccount: 'operations/updateChequeReceivableAccountAction',
      deleteBusinessAutomation: 'operations/deleteBusinessAutomation',
      getAccountCategoryByCode: 'account/getAccountCategoryByCode',
      getBanks: 'operations/getBanks',
    }),

    onSelectChequeReceivableAccount(items, activity, val) {
      this.isReadonly = val === 'edit' ? this.isReadonly = false : this.isReadonly = true
      this.modalTitle = val === 'edit' ? this.$t('Edit Cheque Receivable Account') : this.$t('Cheque Receivable Account')
      this.chequeReceivableAccountFormData = { ...items }
      this.buttonLabel = this.$t('Update')
      this.$root.$emit('bv::show::modal', 'modal-lg')
    },

    async chequeReceivableAccountAction() {
      try {
        this.isLoading = true
        const response = this.buttonLabel === 'Save'
          ? await this.createChequeReceivableAccount(this.chequeReceivableAccountFormData)
          : await this.updateChequeReceivableAccount(this.chequeReceivableAccountFormData)
        const { status } = response
        if (status === 200) {
          this.fetchChequeReceivableAccount()
          this.hideModal('modal-lg')
          this.alertSuccess({ text: this.$t('Cheque clearing account created successfully') })
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoading = false
      }
    },
    handleSubmit(bvModalEvt) {
      bvModalEvt.preventDefault()
      this.$refs.chequeReceivableAccountRules.validate().then(success => {
        if (success) {
          const areYouSure = this.$t('Are you sure you want to')
          const thisCheque = this.$t('this Cheque Receivable Account?')
          this.confirm(this.chequeReceivableAccountAction, { text: `${areYouSure} ${this.buttonLabel} ${thisCheque}` })
        }
      })
    },

    async fetchChequeReceivableAccount() {
      try {
        this.isBusy = true
        const response = await this.getChequeReceivableAccount({
          search: this.filter,
          page: this.currentPage,
          limit: this.perPage,
        })
        const { data, status } = response
        if (status === 200 && data.data) {
          this.isBusy = false
          this.chequeReceivableAccountList = data.data
          this.totalCount = data.recordCount
        } else {
          this.chequeReceivableAccountList = []
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isBusy = false
      }
    },
    // async fetchBanks() {
    //   try {
    //     this.isLoadingBanks = true
    //     const response = await this.getBanks()
    //     const { data, status } = response
    //     if (status === 200 && data.data) {
    //       // eslint-disable-next-line no-nested-ternary
    //       this.bankOptions = data.data.map(item => ({ label: item.name, value: item.code })).sort((a, b) => (a.label === b.label ? 0 : a.label < b.label ? -1 : 1))
    //     } else {
    //       this.bankOptions = []
    //     }
    //   } catch (error) {
    //     this.alertError({ text: error })
    //   } finally {
    //     this.isLoadingBanks = false
    //   }
    // },
    async getAccounts() {
      try {
        const response = await this.getAccountCategoryByCode(10634000)
        const { data, status } = response
        if (status === 200 && data.data) {
          this.chequeReceivableAccountNumberOptions = data.data?.filter(item => item.status === 'Active').map(item => ({
            label: item.name,
            value: item.code.toString(),
          }))
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    async onDeleteChequeReceivableAccount(item) {
      const deleteChequeReceivable = async () => {
        try {
          this.showSpinner = true
          const response = await this.deleteBusinessAutomation({ routeName: 'ChequeReceivableAccount', id: item.id })
          const { status } = response
          if (status === 200) {
            this.fetchChequeReceivableAccount()
            this.alertSuccess({ text: this.$t('Deleted successfully') })
          }
        } catch (error) {
          this.alertError({ text: error })
        } finally {
          this.showSpinner = false
        }
      }
      this.confirm(deleteChequeReceivable, { text: this.$t('Are you sure you want to delete this Cheque Receivable Account?') })
    },
    resetModal() {
      this.chequeReceivableAccountFormData = { ...null }
      this.isLoading = false
    },
    resetFilters() {
      this.filter = { ...null }
    },
    resetFilter() {
      this.filter = { ...null }
      this.fetchChequeReceivableAccount()
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
